import React from 'react';
import CoffeeChatManagementComponent from '../../../components/admin/coffee-chat/CoffeeChatManagementComponent';

const CoffeeChatManagement: React.FC = () => {
  return <CoffeeChatManagementComponent />;
};

export default CoffeeChatManagement;
